module.exports = __webpack_public_path__ + "static/img/028.0c724ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/028.png
// module id = pw9z
// module chunks = 0